import { render, staticRenderFns } from "./ExWhiteSpinner.vue?vue&type=template&id=3cfedc38&scoped=true"
import script from "./ExWhiteSpinner.vue?vue&type=script&lang=js"
export * from "./ExWhiteSpinner.vue?vue&type=script&lang=js"
import style0 from "./ExWhiteSpinner.vue?vue&type=style&index=0&id=3cfedc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfedc38",
  null
  
)

export default component.exports